module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pagination_label":"Showing %{start}-%{end} of <span class=\\"total _bold\\">%{total}</span>"}}')
  delete Component.options._Ctor
}
